import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'xpo-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class XpoEmptyState {}
